import React from 'react';
import { Field } from 'redux-form';

import { groupBy, sortBy, filter, keys } from 'lodash';
import {
  ListButton,
  SimpleForm,
  translate as t,
} from 'admin-on-rest';
import {
  CardActions,
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
  Checkbox,
  TextField,
  Tabs,
  Tab,
  List,
  ListItem,
  FlatButton,
} from 'material-ui';
import Edit from '../components/Edit';
import References from '../components/References';
import FixedToolbar from '../components/FixedToolbar';
import { formatPrice } from '../utils/NumberUtils';
import { getTranslationByLocale } from '../utils/TranslationUtils';
import { regscape } from '../utils/StringUtils';

const Title = t(({ record, translate }) => (
  <span>{record ? translate('edit.title', { title: record.name }) : ''}</span>
));

const cardActionStyle = {
  zIndex: 2,
  display: 'inline-block',
  float: 'right',
};
const styles = {
  wrapper: { padding: '1em 0' },
  tabContent: { padding: '0.3em 1em 1em 1em' },
  headline: {
    fontSize: 24,
    paddingTop: 16,
    marginBottom: 12,
    fontWeight: 400,
  },
  icon: { margin: '-2px 0 0 3px', width: '16px', height: '16px' },
  tabText: { display: 'flex', flexDirection: 'row', alignItems: 'center' },
};

const EditActions = ({ basePath }) => (
  <CardActions style={cardActionStyle}>
    <ListButton basePath={basePath} />
  </CardActions>
);

export default t((props) => (
  <Edit actions={<EditActions {...props} />} title={<Title />} {...props}>
    <SimpleForm submitOnEnter={false} redirect={null} toolbar={<FixedToolbar />}>
      <References {...props} references={[{ name: 'categories', filter: { promotion: { $ne: true } } }]}>
        <Activation {...props} addField />
      </References>
    </SimpleForm>
  </Edit>
));

const Sheet = ({ mainCategory, groupedProducts, groupedCategories, productTitles, record, query, queryFn, locale, translate }) => {
  if (!groupedCategories || !groupedProducts) return null;
  return (
    <List>
      {groupedCategories && keys(groupedCategories[mainCategory]).map((category) => (
        groupedProducts[mainCategory] &&
        groupedProducts[mainCategory][category] &&
        groupedProducts[mainCategory][category].filter((choice) => queryFn(query, choice)).length > 0 &&
        <ListItem
          key={groupedCategories[mainCategory][category]}
          primaryTogglesNestedList
          primaryText={<strong>{groupedCategories[mainCategory][category]}</strong>}
          nestedItems={[
            <Table
              selectable={false}
            >
              <TableBody displayRowCheckbox={false}>
                {
                  groupedProducts[mainCategory] &&
                  groupedProducts[mainCategory][category] &&
                  groupedProducts[mainCategory][category]
                    .filter((choice) => queryFn(query, choice))
                    .map(({ title, internalName, markets, code, mainImageUrl }) => {
                      const assortmentProduct = record.products.find((p) => p.product === code);
                      const index = record.products.findIndex((p) => p.product === code);
                      const market = markets.find((m) => m.marketId === record.market._id);
                      const translatedTitle = getTranslationByLocale(title, locale);

                      return (


                        <TableRow key={code} style={{ display: 'flex', alignItems: 'center' }}>
                          <TableRowColumn width={15} style={{ height: 'auto !important' }}>
                            {console.log('code', code)}
                            <Field
                              name={`products[${index}].active`}
                              component={({ input: { value, onChange } }) => (
                                <Checkbox checked={value} onCheck={(e, val) => onChange(val)} />
                              )}
                            />
                          </TableRowColumn>
                          <TableRowColumn style={{ width: '100%', height: 'auto !important' }}>
                            <span style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%', justifyContent: 'space-between' }}>
                              <span style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                {mainImageUrl && <img alt={code} src={`http://images.pinchos.se/unsafe/${50}x${40}/smart/${mainImageUrl.src}`} />}
                                <div style={{ marginLeft: '1.2em', fontSize: '1.2em' }}>
                                  {translatedTitle}
                                  &nbsp;
                                  {/* if any other products have the exact same name, show the internal name */}
                                  {productTitles.splice(productTitles.indexOf(translatedTitle)).includes(translatedTitle) ?
                                    `(${internalName})` : ''
                                  }
                                </div>
                                <div style={{ marginLeft: '1.2em' }}>
                                  {
                                    assortmentProduct && assortmentProduct.price ? (
                                      formatPrice(
                                        assortmentProduct.price,
                                        record.market.currencyPrecision,
                                        record.market.currencyCode
                                      )
                                    ) : market && market.suggestedPrice && (
                                      formatPrice(
                                        market.suggestedPrice,
                                        record.market.currencyPrecision,
                                        record.market.currencyCode
                                      )
                                    )
                                  }
                                </div>
                              </span>
                              <a href={`#/products/${code}/show`}><FlatButton primary label={translate('show', { smart_count: 1 })} /></a>
                            </span>
                          </TableRowColumn>
                        </TableRow>
                      );
                    })
                }
              </TableBody>
            </Table>,
          ]}
        />
      ))}
    </List>
  );
};

const Activation = class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      queryFn: () => true,
      groupedProducts: null,
      groupedCategories: null,
    };
  }

  shouldComponentUpdate = (nextProps, nextState) => {
    console.log('shouldUpdateCategories', !this.state.groupedCategories && this.props.choices.categories.length);
    if (!this.state.groupedCategories && this.props.choices.categories.length) {
      return true;
    }
    console.log('shouldUpdateProducts', !this.state.groupedProducts || (!this.state.groupedProducts && nextState.groupedProducts) || (!this.props.record.productsProduct && nextProps.record.productsProduct && nextProps.record.productsProduct.length));
    if (!this.state.groupedProducts || (!this.state.groupedProducts && nextState.groupedProducts) || (!this.props.record.productsProduct && nextProps.record.productsProduct && nextProps.record.productsProduct.length)) {
      return true;
    }
    if (this.state.query !== nextState.query) {
      return true;
    }
    return false;
  }

  componentWillUpdate = (nextProps) => {
    let changes = {};
    if (!this.state.groupedCategories && this.props.choices.categories.length) {
      const groupedCategories = {
        drink: {},
        food: {},
      };
      nextProps.choices.categories.forEach((category) => {
        groupedCategories[category.mainCategory][category._id] = getTranslationByLocale(category.title, nextProps.locale);
      });
      changes = {
        ...changes,
        groupedCategories,
      };
    }
    if (!this.state.groupedProducts && nextProps.record.productsProduct && nextProps.record.productsProduct.length) {
      const groupedProducts = {
        drink: groupBy(sortBy(filter(nextProps.record && nextProps.record.productsProduct, (p) => p.mainCategory === 'drink'), 'position'), 'category._id'),
        food: groupBy(sortBy(filter(nextProps.record && nextProps.record.productsProduct, (p) => p.mainCategory === 'food'), 'position'), 'category._id'),
      };
      changes = {
        ...changes,
        groupedProducts,
        productTitles: nextProps.record.productsProduct && nextProps.record.productsProduct.map((prod) => getTranslationByLocale(prod.title, nextProps.locale)),
      };
    }
    if (keys(changes).length > 0) {
      this.setState({
        ...this.state,
        ...changes,
      });
    }
  }

  render() {
    const { translate, locale } = this.props;

    return (
      <div>
        <TextField
          floatingLabelText={translate('search', { queryables: `${translate('name')}, ${translate('categories')}` })}
          onChange={(e) => {
            this.setState({
              query: e.target.value,
              queryFn: (query, choice) => (
                query ? (
                  new RegExp(regscape(query), 'gi').test( // search for internalName
                    choice.internalName
                  )
                  ||
                  new RegExp(regscape(query), 'gi').test( // or category name
                    getTranslationByLocale(choice.title, locale)
                  )
                  ||
                  new RegExp(regscape(query), 'gi').test( // or category name
                    getTranslationByLocale(choice.category && choice.category.title, locale)
                  )
                ) : true
              ),
            });
          }}
        />
        <Tabs>
          <Tab
            key="drink"
            label={
              <span style={styles.tabText}>
                Dryck
              </span>
            }
          >
            <Sheet {...this.props} {...this.state} mainCategory="drink" />
          </Tab>
          <Tab
            key="food"
            label={
              <span style={styles.tabText}>
                Mat
              </span>
            }
          >
            <Sheet {...this.props} {...this.state} mainCategory="food" />
          </Tab>
        </Tabs>
      </div>
    );
  }
};

Activation.defaultProps = {
  choices: { categories: [] },
  record: {},
};
